// src/store/aiPrompt/thunk.js

import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { t } from "i18next";

// --- IMPORTANT ---
// Import your actual API helper functions here.
import {
  getAllPromptsAPI,
  saveOrUpdatePromptAPI, 
  deletePromptAPI,
} from "../../helpers/fakebackend_helper";

/**
 * Thunk to fetch all AI Prompts
 */
export const fetchAllPrompts = createAsyncThunk(
  "AIPrompt/fetchAll",
  async (_, thunkAPI) => {
    try {
      const response = await getAllPromptsAPI();
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);

/**
 * Thunk to save (create or update) an AI Prompt.
 * The API endpoint handles whether it's a create or update
 * based on the presence of an 'ID' in the payload.
 */
export const savePrompt = createAsyncThunk(
  "AIPrompt/save",
  async (prompt, thunkAPI) => {
    try {
      const response = await saveOrUpdatePromptAPI(prompt);

      // Give appropriate user feedback
      const message = prompt.ID
        ? "Prompt updated successfully"
        : "Prompt created successfully";
      toast.success(t(response.message || message));

      // The API should return the created/updated prompt object in the 'data' array
      return response.data;
    } catch (error) {
      const errorMessage = error || "Operation failed";
      toast.error(t(errorMessage));
      return thunkAPI.rejectWithValue(errorMessage);
    }
  }
);